import React from 'react';
import { useSelector } from 'react-redux';
import { Fire, Time, Tools } from '../../../services'

import { Input, Button } from 'reactstrap'
import { Headerbar, Loader, StatusBox, ConfirmButton, ListContainer } from '../../Reusable'

import FadeIn from 'react-fade-in';
import PartnerDetails from './PartnerDetails'

const { useHistory } = require('react-router-dom')

interface Props {
  
}
const PartnersScreen: React.FC<Props> = (props) => {

  const history = useHistory()
  const [error, setError] = React.useState('')
  const user = useSelector(state => state.authReducer.user)

  const onFetch = async () => {
    try {
      const list = await Fire.list(Fire.store().collection('partners'))
      for (const item of list) {

      }
      return list
    } catch (err) {
      setError("Impossible de charger les partenaires")
      console.warn(err)
    }
    return []
  }

  const sorting = (search: string, items: any[]) => {
    return items.filter((item) => Tools.matchesSearch(search, item.name))
  }

  return (
    <div className="wrapper">
      <Headerbar
        title={'Nos partenaires'}
        />
      <div className="content-wrapper">
        <div className="content">
          <div className="container-fluid">

            <FadeIn>

              <ListContainer
                title="Annuaire"
                onCreate={() => history.push('/admin/partner/new')}
                createTitle="Créer un partenaire"
                searchTitle="Rechercher un partenaire..."
                error={error}
                onFetch={onFetch}
                sorting={sorting}
                renderColumns={({ refresh }) => ([
                  { name: 'Image', accessor: 'image', cell: (item) => (
                    <div className="table-preview">
                      {item.pictures && item.pictures.length &&
                        <img alt={item.name} src={item.pictures[0]} />
                      }
                    </div>
                  ) },
                  { name: 'Nom', string: 'name', sortable: true, accessor: 'name' },
                  { name: 'Statut', accessor: 'status', cell: (item) => (
                    <StatusBox
                      status={item.active ? 'Affiché' : 'Caché'}
                      type={item.active ? 'success': 'off'}
                      />
                  ) },
                  { name: 'Actions', accessor: 'actions', hasButton: true, cell: (item) => (
                    <div>
                      <ConfirmButton
                        title={'Modifier'}
                        noConfirm
                        confirmTitle={''}
                        onPress={(e) => {
                          e.stopPropagation();
                          history.push('/admin/partner/' + item.id)
                        }} />
                    </div>
                  )},
                ])}
                expandableRow={(item: any, { refresh }) => (
                  <PartnerDetails data={item} refresh={refresh} />
                )}
                />

            </FadeIn>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PartnersScreen